import {Component, Input, OnInit} from '@angular/core';
import {Survey, SurveyResultsSection} from "../../../../../../model/common";

@Component({
  selector: 'app-survey-results-compensation',
  templateUrl: './survey-results-compensation.component.html',
  styleUrls: ['./survey-results-compensation.component.scss']
})
export class SurveyResultsCompensationComponent implements OnInit {

  @Input('survey') survey: Survey;
  @Input('results') results: SurveyResultsSection;
  @Input('showResultsBelowSafeHarbor') showResultsBelowSafeHarbor: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  getKeys(object) {
    return Object.keys(object);
  }

}
